import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast, { Toaster } from "react-hot-toast";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import * as services from "./../services/services";
import loginIllustration from "../images/dog.jpg"; // ภาพด้านซ้าย
import logo from "../images/itaam-company-2.png";
import { Link } from "react-router-dom";

const schema = yup.object().shape({
  username: yup.string().email("กรุณากรอก Email ให้ถูกต้อง").required("กรุณากรอก Email"),
  password: yup
    .string()
    .min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร")
    .max(20, "รหัสผ่านต้องไม่เกิน 20 ตัวอักษร")
    .notOneOf([yup.ref("username"), null], "รหัสผ่านไม่ถูกต้อง")
    .required("กรุณากรอกรหัสผ่าน"),
});

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { username: "", password: "" },
  });

  const onSubmitNew = async (data) => {
    const payload = { username: data.username, password: data.password };
    try {
      const Response = await services.login(payload);
      const Data = Response.data;

      if (!Data.success) {
        toast.error(Data.error || "เข้าสู่ระบบไม่สำเร็จ");
        return;
      }

      const { accessToken } = Data.data;
      localStorage.setItem("accessToken", accessToken);

      try {
        const payloadbow = { email: "test@example.com", password: 1234 };
        const ResponseBow = await services.loginBow(payloadbow);
        const { access } = ResponseBow.data;
        localStorage.setItem("bow_accessToken", access);
      } catch (bowError) {
        const status = bowError?.response?.status;
        if (status === 401) {
          toast.error("ไม่สามารถเชื่อมต่อกับระบบ BOW ได้: ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง");
        } else if (status === 500) {
          toast.error("ไม่สามารถเชื่อมต่อกับระบบ BOW ได้: เซิร์ฟเวอร์ขัดข้อง กรุณาลองใหม่ภายหลัง");
        } else {
          toast.error("ไม่สามารถเชื่อมต่อกับระบบ BOW ได้");
        }
        // ยังคง navigate ต่อแม้ BOW login ล้มเหลว
      }
      console.log("login success");
      navigate("/dashboard");
    } catch (error) {
      const status = error?.response?.status;
      if (status === 401) {
        toast.error("อีเมลหรือรหัสผ่านไม่ถูกต้อง");
      } else if (status === 403) {
        toast.error("บัญชีนี้ถูกระงับการใช้งาน");
      } else if (status === 500) {
        toast.error("เซิร์ฟเวอร์ขัดข้อง กรุณาลองใหม่ภายหลัง");
      } else {
        toast.error(error?.response?.data?.error || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    }
  };

  return (
    <div className="flex min-h-screen">
      <Toaster />

      {/* ฝั่งซ้าย (30%) */}
      <div
        className="hidden md:flex w-[40%] bg-cover bg-center"
        style={{
          backgroundImage: `url(${loginIllustration})`,
        }}
      ></div>

      {/* ฝั่งขวา (70%) */}
      <div className="flex w-[60%] items-center justify-center bg-white">
        <form
          onSubmit={handleSubmit(onSubmitNew)}
          className="w-full max-w-md px-8 py-10"
        >
          <div className="flex justify-center mb-6">
            <img src={logo} alt="Logo" className="w-32" />
          </div>

          <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
            BOW HIS. โปรแกรมดูแลลูกค้าสำหรับโรงพยาบาลสัตว์
          </h2>
          <h2 className="text-xl font-bold text-gray-400 text-center mb-6">
            Empowering Vets, Enriching Care
          </h2>
          <div className="mb-4">
            <label className="text-sm font-semibold text-gray-700">
              Email
            </label>
            <input
              type="text"
              placeholder="Email"
              {...register("username")}
              className="w-full mt-1 px-3 py-2 border rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            />
            {errors.username && (
              <p className="text-red-500 text-xs mt-1">
                {errors.username.message}
              </p>
            )}
          </div>

          <div className="mb-4">
            <label className="text-sm font-semibold text-gray-700">
              รหัสผ่าน
            </label>
            <div className="relative mt-1">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="รหัสผ่าน"
                {...register("password")}
                className="w-full px-3 py-2 pr-11 border rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              />
              <button
                type="button"
                aria-label={showPassword ? "ซ่อนรหัสผ่าน" : "แสดงรหัสผ่าน"}
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-gray-500 hover:text-gray-700"
              >
                {showPassword ? (
                  <VisibilityOff fontSize="small" />
                ) : (
                  <Visibility fontSize="small" />
                )}
              </button>
            </div>
            {errors.password && (
              <p className="text-red-500 text-xs mt-1">
                {errors.password.message}
              </p>
            )}
          </div>

          <div className="flex items-center justify-between mb-6">
            <label className="flex items-center text-sm">
              <input type="checkbox" className="mr-2" /> Stay Logged in
            </label>
            <Link
              to="/auth/forgot-password"
              className="text-sm text-indigo-500 hover:underline"
            >
              ลืมรหัสผ่าน?
            </Link>
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-md transition"
          >
            เข้าสู่ระบบ
          </button>

          <p className="text-center text-sm text-gray-500 mt-6">
            ยังไม่มีบัญชี?{" "}
            <Link
              to="/auth/register"
              className="text-indigo-500 font-semibold hover:underline"
            >
              สมัครสมาชิก
            </Link>
          </p>

          <div className="text-center text-xs text-gray-400 mt-8">
            <a href="#" className="hover:underline">
              ข้อตกลงการใช้งาน
            </a>{" "}
            |{" "}
            <a href="#" className="hover:underline">
              นโยบายความเป็นส่วนตัว
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
